import React from 'react';
import { Link } from 'react-router-dom';
import Header from './../../../component/common/LeaveHeader';
import AddHoliday from '../../../component/holiday/Add';
import Loader from './../../../component/common/Loader';

import CONSTANT from './../../../constant';
import { updateHoliday, getHolidayDetail } from './../../../actions/MasterAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.match.params.code,
            detail: undefined,
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.home;

        getHolidayDetail(this.state.code).then((res: any) => {
            this.setState({ detail: res.result });
        });
    }

    render() {
        const { showLoader, detail } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Holiday detail</h1>
                            </div>
                        </div>
                        {
                            detail === undefined && <p>Loading...</p>
                        }
                        {
                            detail !== undefined && <AddHoliday
                                detail={detail}
                                onSubmit={this.onSubmit}
                            />
                        }

                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onSubmit = (model: any) => {
        updateHoliday(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    alert('record added successfully');
                    this.props.history.push(CONSTANT.component.adminHolidayList.url);
                } else {
                    alert(res.error);
                }
            }
        });
    }
}

export default ComponentName;